import { LogoFooter } from "../data";
import Logo from "./Logo";
import { NavLink } from "react-router-dom";
import ContactNavigation from "./Navbar/ContactNavigation";

function Footer() {
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  return (
    <section className="footer-container container">
      <div className="footer-content">
        <div className="footer-logo">
          <Logo data={LogoFooter} />
        </div>
        <section className="footer-text">
          <small>
            Desenvolvido por{" "}
            <NavLink to="https://www.francinemelopepe.de/" target="_blank">
              Francine Pêpe
            </NavLink>
          </small>
          <div className="footer-copyright">
            <small>&copy; Copyright {getCurrentYear()}</small>
          </div>
        </section>
      </div>
      <ContactNavigation />
    </section>
  );
}

export default Footer;
